<script setup lang="ts">
import { NRadioGroup } from 'naive-ui'
import { useAttrs } from 'vue'

interface RadioOption {
  label: string
  value: any
  disabled?: boolean
  [key: string]: any
}

const props = withDefaults(defineProps<{
  value?: any
  defaultValue?: any
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  name?: string
  options?: RadioOption[]
  direction?: 'horizontal' | 'vertical'
  onUpdateValue?: (value: any) => void
  onChange?: (value: any) => void
}>(), {
  value: undefined,
  defaultValue: undefined,
  disabled: false,
  size: 'medium',
  name: undefined,
  options: () => [],
  direction: 'horizontal',
})

const emit = defineEmits<{
  'update:value': [value: any]
  'change': [value: any]
}>()

const attrs = useAttrs()

const onUpdateValue = (value: any) => {
  emit('update:value', value)
}

const onChange = (value: any) => {
  emit('change', value)
}
</script>

<template>
  <NRadioGroup
    :value="value"
    :default-value="defaultValue"
    :disabled="disabled"
    :size="size"
    :name="name"
    :options="options"
    :direction="direction"
    v-bind="attrs"
    @update:value="onUpdateValue"
    @change="onChange"
  >
    <template #default>
      <slot />
    </template>
  </NRadioGroup>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
